<script lang="ts">
    
    import { createEventDispatcher } from "svelte";

    export let accept: string = undefined;
    export let multiple = false;

    const dispatch = createEventDispatcher();

    let input: HTMLInputElement;

    export function openDialog(): void {
        input.click();
    }

    function onChange(): void {
        const files = [...input.files];
        input.value = '';
        dispatch('files', files);
    }

</script>

<input
    bind:this={input}
    type="file"
    style="display: none;"
    {multiple}
    {accept}
    on:change={onChange}>
